import { Component, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeSharedModule } from '../../font-awesome/font-awesome';
import { DialogService } from '../../services/dialog.service';

export const UNSAVED_CHANGES_MODAL_ID = 'unsaved_changes_modal';

/**
 * @deprecated Use DialogService.open(UNSAVED_CHANGES_MODAL_ID) instead
 */
export const showUnsavedChangesModal = () => {
  const element = document.getElementById(UNSAVED_CHANGES_MODAL_ID) as HTMLDialogElement;
  element?.showModal();
};

/**
 * @deprecated Use DialogService.close(UNSAVED_CHANGES_MODAL_ID) instead
 */
export const closeUnsavedChangesModal = () => {
  const element = document.getElementById(UNSAVED_CHANGES_MODAL_ID) as HTMLDialogElement;
  element?.close();
};

@Component({
  selector: 'app-unsaved-changes-confirmation-modal',
  imports: [CommonModule, FontAwesomeSharedModule],
  templateUrl: './unsaved-changes-confirmation-modal.component.html',
})
export class UnsavedChangesConfirmationModalComponent {
  private dialogService = inject(DialogService);
  modalId = UNSAVED_CHANGES_MODAL_ID;

  @Output() saveAndClose = new EventEmitter<void>();
  @Output() closeWithoutSaving = new EventEmitter<void>();
  @Output() continueEditing = new EventEmitter<void>();

  closeModal() {
    this.continueEditing.emit();
    this.dialogService.close(UNSAVED_CHANGES_MODAL_ID);
  }

  onBackdropClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.id === this.modalId) {
      this.closeModal();
    }
  }

  onSaveAndClose() {
    this.saveAndClose.emit();
    this.dialogService.close(UNSAVED_CHANGES_MODAL_ID);
  }

  onCloseWithoutSaving() {
    this.closeWithoutSaving.emit();
    this.dialogService.close(UNSAVED_CHANGES_MODAL_ID);
  }
}
